// Nested forms: remove required attribute
// TODO: still needed?
document.addEventListener('nested:fieldRemoved', function(e) {
  $('[required]', e.field).removeAttr('required')
})
